export const boundariesCautious = [
  [5000, 5000],
  [4878, 5160],
  [4839, 5239],
  [4812, 5304],
  [4793, 5363],
  [4777, 5417],
  [4765, 5469],
  [4755, 5518],
  [4747, 5566],
  [4741, 5612],
  [4736, 5657],
  [4732, 5702],
  [4728, 5745],
  [4726, 5788],
  [4724, 5830],
  [4723, 5872],
  [4723, 5914],
  [4723, 5955],
  [4723, 5995],
  [4724, 6036],
  [4725, 6076],
  [4727, 6116],
  [4729, 6156],
  [4731, 6196],
  [4734, 6235],
  [4737, 6275],
  [4740, 6314],
  [4744, 6353],
  [4747, 6392],
  [4751, 6431],
  [4755, 6470],
  [4760, 6509],
  [4764, 6548],
  [4769, 6587],
  [4774, 6626],
  [4779, 6665],
  [4784, 6704],
  [4790, 6743],
  [4795, 6782],
  [4801, 6821],
  [4807, 6860],
  [4813, 6899],
  [4819, 6938],
  [4826, 6977],
  [4832, 7016],
  [4838, 7055],
  [4845, 7094],
  [4852, 7134],
  [4859, 7173],
  [4866, 7212],
  [4873, 7252],
  [4880, 7291],
  [4888, 7331],
  [4895, 7371],
  [4903, 7410],
  [4910, 7450],
  [4918, 7490],
  [4926, 7530],
  [4934, 7570],
  [4942, 7611],
  [4950, 7651],
  [4958, 7691],
  [4966, 7732],
  [4975, 7772],
  [4983, 7813],
  [4992, 7854],
  [5000, 7895],
  [5009, 7936],
  [5018, 7977],
  [5027, 8018],
  [5035, 8060],
  [5044, 8101],
  [5054, 8143],
  [5063, 8185],
  [5072, 8226],
  [5081, 8268],
  [5091, 8310],
  [5100, 8353],
  [5110, 8395],
  [5119, 8437],
  [5129, 8480],
  [5139, 8523],
  [5148, 8566],
  [5158, 8609],
  [5168, 8652],
  [5178, 8695],
  [5188, 8739],
  [5198, 8782],
  [5208, 8826],
  [5219, 8870],
  [5229, 8914],
  [5239, 8958],
  [5250, 9002],
  [5260, 9046],
  [5271, 9091],
  [5282, 9136],
  [5292, 9181],
  [5303, 9226],
  [5314, 9271],
  [5325, 9316],
  [5336, 9362],
  [5347, 9407],
  [5358, 9453],
  [5369, 9499],
  [5380, 9545],
  [5391, 9591],
  [5402, 9638],
  [5414, 9684],
  [5425, 9731],
  [5437, 9778],
  [5448, 9825],
  [5460, 9872],
  [5471, 9920],
  [5483, 9967],
  [5495, 10015],
  [5507, 10063],
  [5519, 10111],
  [5531, 10159],
  [5543, 10208],
  [5555, 10256],
  [5567, 10305],
];

export const developmentCautious = [
  5000, 5018, 5036, 5054, 5073, 5091, 5109, 5128, 5146, 5165, 5184, 5202, 5221, 5240,
  5259, 5278, 5297, 5316, 5335, 5355, 5374, 5393, 5413, 5432, 5452, 5472, 5492, 5511,
  5531, 5551, 5571, 5591, 5612, 5632, 5652, 5673, 5693, 5714, 5734, 5755, 5776, 5797,
  5818, 5839, 5860, 5881, 5902, 5924, 5945, 5967, 5988, 6010, 6031, 6053, 6075, 6097,
  6119, 6141, 6163, 6186, 6208, 6230, 6253, 6276, 6298, 6321, 6344, 6367, 6390, 6413,
  6436, 6459, 6483, 6506, 6530, 6553, 6577, 6601, 6624, 6648, 6672, 6696, 6721, 6745,
  6769, 6794, 6818, 6843, 6868, 6893, 6917, 6942, 6968, 6993, 7018, 7043, 7069, 7094,
  7120, 7146, 7171, 7197, 7223, 7249, 7276, 7302, 7328, 7355, 7381, 7408, 7435, 7462,
  7489, 7516, 7543, 7570, 7598, 7625, 7653, 7680, 7708,
];

export const fluctuationCautious = [
  5000, 4971, 4935, 4998, 4964, 5033, 5109, 4974, 4858, 4893, 5075, 5148, 5221, 5241,
  5293, 5520, 5518, 5581, 5539, 5399, 5321, 5315, 5422, 5456, 5452, 5607, 5783, 5888,
  5743, 5702, 5650, 5562, 5601, 5672, 5758, 5783, 5693, 5590, 5532, 5431, 5382, 5332,
  5331, 5484, 5583, 5743, 5893, 5975, 5945, 5897, 5946, 6047, 6257, 6430, 6289, 6225,
  6212, 6352, 6358, 6304, 6208, 6205, 6368, 6558, 6703, 6792, 6658, 6456, 6532, 6571,
  6539, 6506, 6483, 6649, 6655, 6687, 6687, 6970, 7004, 6957, 6929, 6710, 6668, 6676,
  6769, 6671, 6517, 6396, 6437, 6470, 6456, 6425, 6506, 6707, 6753, 6816, 7069, 7064,
  6999, 6818, 6765, 6645, 6575, 6658, 6788, 6977, 7107, 7309, 7381, 7613, 7819, 8068,
  8126, 8070, 7938, 7847, 7735, 7627, 7612, 7607, 7708,
];
